export const SET_IS_CATEGORY_LOADED = 'category/SET_IS_LOADED';

export const setIsCategoryLoaded = (categoryId, isLoaded) => ({
  type: SET_IS_CATEGORY_LOADED,
  payload: {
    categoryId,
    isLoaded,
  },
});
